export const userTeamSmartImagesApiSavingSelector = state =>
  state.api.userTeamSmartImages.isSaving;
